/* BB 2026 — two small interface behaviours the stylesheet cannot express.
   1. The PDP panels open their first tab, on a wide screen only.
   2. The search overlay closes when its scrim is clicked.
   A tab strip with nothing active reads as broken; a stack of accordions that
   opens itself does not, so the phone is left closed. The theme's own
   disclosure owns the state — this only ever sends it a click, and only until
   one lands, so a panel the visitor closes stays closed. */
(function () {
  if (window.__bbTabsReady) return;
  window.__bbTabsReady = true;

  // The same width the stylesheet turns the stack into a strip at.
  var wide = window.matchMedia('(min-width: 1250px)');
  var done = false;

  function tryOpen() {
    if (done || !wide.matches) return done;
    var acc = document.querySelector('.product-accordion');
    if (!acc) return false;
    if (acc.querySelector('.accordion__title[aria-expanded="true"]')) { done = true; return true; }
    var first = acc.querySelector('.accordion__title[aria-expanded]');
    if (!first) return false;            // the theme's disclosure has not bound yet
    first.click();
    return false;                        // confirmed on the next pass
  }

  // The product section settles slowly on this site, so keep asking for a few
  // seconds rather than guessing one moment.
  function boot() {
    done = false;
    var tries = 0;
    var timer = setInterval(function () {
      if (tryOpen() || ++tries > 24) clearInterval(timer);
    }, 250);
    tryOpen();
  }

  if (document.readyState !== 'loading') boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  /* ---------- the search scrim ----------
     The popdown used to be a bar at the top of the page, so the theme could
     close it on any click outside itself. It now covers the window, so every
     click is inside it; a click that lands on the scrim rather than on the
     card has to be turned back into a close. */
  document.addEventListener('click', function (e) {
    var layer = e.target.closest('.search-popdown');
    if (!layer || !layer.classList.contains('is-visible')) return;
    // Only a click on the layer itself — never one that passed through the card.
    if (e.target !== layer) return;
    var close = layer.querySelector('[data-close-popdown]');
    if (close) close.click();
  });
  // Crossing into the strip layout with everything closed leaves no active tab.
  if (wide.addEventListener) wide.addEventListener('change', function () { if (wide.matches) boot(); });
})();
